import * as Immutable from "immutable";
import isDeepEqual from "stores/isDeepEqual";
import View from "views/logic/views/View";
import normalizeSearchURLQueryParams from "views/logic/NormalizeSearchURLQueryParams";
import createSearch from "views/logic/slices/createSearch";
import GlobalOverride from "views/logic/search/GlobalOverride";
const bindSearchParamsFromQuery = async ({ query, view, executionState }) => {
  var _a;
  const { queryString, timeRange, streamsFilter, streamCategoriesFilter } = normalizeSearchURLQueryParams(query);
  if (view.type === View.Type.Dashboard) {
    if (!queryString && !timeRange) {
      return [view, executionState];
    }
    const currentOverride = (_a = executionState.globalOverride) != null ? _a : GlobalOverride.empty();
    let overrideBuilder = currentOverride.toBuilder();
    if (queryString) {
      overrideBuilder = overrideBuilder.query(queryString);
    }
    if (timeRange) {
      overrideBuilder = overrideBuilder.timerange(timeRange);
    }
    const newOverride = overrideBuilder.build();
    if (isDeepEqual(newOverride, currentOverride)) {
      return [view, executionState];
    }
    const newExecutionState = executionState.toBuilder().globalOverride(newOverride).build();
    return [view, newExecutionState];
  }
  if (view.type !== View.Type.Search) {
    return [view, executionState];
  }
  if (!queryString && !timeRange && !streamsFilter && !streamCategoriesFilter) {
    return [view, executionState];
  }
  const { queries } = view.search;
  if (queries.size !== 1) {
    throw new Error("Searches must only have a single query!");
  }
  const firstQuery = queries.first();
  let queryBuilder = firstQuery.toBuilder();
  if (queryString) {
    queryBuilder = queryBuilder.query(queryString);
  }
  if (timeRange) {
    queryBuilder = queryBuilder.timerange(timeRange);
  }
  const combinedFilters = streamsFilter && streamCategoriesFilter ? Immutable.Map({
    type: "or",
    filters: Immutable.List.of(streamsFilter, streamCategoriesFilter)
  }) : streamsFilter || streamCategoriesFilter;
  if (combinedFilters) {
    queryBuilder = queryBuilder.filter(combinedFilters);
  }
  const newQuery = queryBuilder.build();
  if (isDeepEqual(newQuery, firstQuery)) {
    return [view, executionState];
  }
  const newSearch = await createSearch(view.search.toBuilder().newId().queries([newQuery]).build());
  const newView = view.toBuilder().search(newSearch).build();
  return [newView, executionState];
};
export default bindSearchParamsFromQuery;
